<template>
  <span class="event-log-level" :class="[levelClass, sizeClass]">
    {{ label }}
  </span>
</template>

<script>
import { EventLogLevel, enumValueToLabel } from "@/enums";

const LEVEL_CLASS_MAP = {
  LOW: "event-log-level--low",
  MEDIUM: "event-log-level--medium",
  HIGH: "event-log-level--high",
  DEFAULT: "event-log-level--default",
};

const SIZE_CLASS_MAP = {
  small: "event-log-level--small",
  normal: "event-log-level--normal",
  large: "event-log-level--large",
  xlarge: "event-log-level--xlarge",
};

export default {
  name: "RenderEventLogLevel",
  props: {
    modelValue: {
      type: [Number, String],
      default: null,
    },
    size: {
      type: String,
      default: "normal",
      validator: (value) => ["small", "normal", "large", "xlarge"].includes(value),
    },
  },
  computed: {
    normalizedValue() {
      if (this.modelValue === null || this.modelValue === undefined || this.modelValue === "") {
        return undefined;
      }
      const numericValue = Number(this.modelValue);
      if (!Number.isNaN(numericValue)) {
        return numericValue;
      }
      const key = String(this.modelValue).trim().toUpperCase();
      if (Object.prototype.hasOwnProperty.call(EventLogLevel, key)) {
        return EventLogLevel[key];
      }
      return undefined;
    },
    levelKey() {
      const entry = Object.entries(EventLogLevel).find(([, val]) => val === this.normalizedValue);
      return entry ? entry[0] : undefined;
    },
    label() {
      if (typeof this.normalizedValue === "undefined") {
        return "--";
      }
      return enumValueToLabel(EventLogLevel, this.normalizedValue);
    },
    levelClass() {
      if (!this.levelKey) {
        return LEVEL_CLASS_MAP.DEFAULT;
      }
      return LEVEL_CLASS_MAP[this.levelKey] || LEVEL_CLASS_MAP.DEFAULT;
    },
    sizeClass() {
      return SIZE_CLASS_MAP[this.size] || SIZE_CLASS_MAP.normal;
    },
  },
};
</script>

<style lang="scss" scoped>
.event-log-level {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.125rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  border: 1px solid transparent;
  text-transform: capitalize;
}

.event-log-level--small {
  padding: 0.1rem 0.5rem;
  font-size: 0.65rem;
}

.event-log-level--normal {
  padding: 0.125rem 0.75rem;
  font-size: 0.75rem;
}

.event-log-level--large {
  padding: 0.2rem 1rem;
  font-size: 0.875rem;
}

.event-log-level--xlarge {
  padding: 0.5rem 1.25rem;
  font-size: 1rem;
  font-weight: 500;
}

.event-log-level--low {
  $color: #3b82f6; // tailwind blue-500
  color: $color;
  border-color: $color;
  background: rgba(59, 130, 246, 0.12);
}

.event-log-level--medium {
  $color: #eab308; // tailwind yellow-500
  color: $color;
  border-color: $color;
  background: rgba(234, 179, 8, 0.16);
}

.event-log-level--high {
  $color: #ef4444; // tailwind red-500
  color: $color;
  border-color: $color;
  background: rgba(239, 68, 68, 0.15);
}

.event-log-level--default {
  background: rgba(148, 163, 184, 0.15);
  color: #475569;
  border-color: rgba(148, 163, 184, 0.4);
}
</style>
